import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 24,
    fontStyle: 'bold',
  },
  description: {
    textAlign: 'left',
    paddingLeft: 8,
    lineHeight: '1.4',
    fontSize: 14
  },
  topBorder: {
    borderBottomWidth: 1,
  },
  emptyField: {
    width: '50%',
    textAlign: 'left',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
    lineHeight: '1.4',
    fontSize: 14
  },
  checkbox: {
    width: '2%',
    height: '45%',
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
  }
});

const Disclaimer = ({ disclaimerData }) => {
  const rows = disclaimerData.map(item =>
    <View>
      <View style={styles.row} key={disclaimerData._id}>
        <Text style={styles.checkbox}/>
        <Text style={styles.description}>{item.disclaimer}</Text>
      </View>
    </View>
  )
  return (
    <View style={{marginTop: '35px'}}>
      {rows}
    </View>)
}

export default Disclaimer
